export function getDefaultStartTime() {
    let outDate = new XDate(new Date());
    return outDate.toString("yyyy-MM-dd");
}

export function getDefaultEndTime() {
    let outDate = new XDate(new Date());
    return outDate.addDays(1).toString("yyyy-MM-dd");
}

export function formatDate(date) {
    if (date === null) return;
    let outDate = new XDate(date);
    return outDate.toString("yyyy-MM-dd");
}

export function formatDateTime(date) {
    let outDate = new XDate(date);
    return outDate.toString("yyyy-MM-dd HH:mm:ss");
}

export function formatDateTimes(date) {
    let outDate = new XDate(date);
    return outDate.toString("HH:mm:ss");
}

export function formatDay(date) {
    var aDate, oDate1, oDate2, iDays
    let sDate1 = new XDate(date).toString("yyyy-MM-dd");
    let sDate2 = new XDate().toString("yyyy-MM-dd");

    aDate = sDate1.split("-")
    oDate1 = new Date(aDate[0], aDate[1], aDate[2]) //转换为12-18-2006格式  
    aDate = sDate2.split("-")
    oDate2 = new Date(aDate[0], aDate[1], aDate[2])
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数  
    return iDays
}


export function toFixedEight(x,index) {   
    if(x.toString().indexOf('.') !== -1){
        if(x.toString().split(".")[1].length > index){
            x = x.toFixed(index)
        }
    }
    return x 
} 